module.exports = __webpack_public_path__ + "img/cui.72eb38fa.png";